import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { painPoints } from "../data/mock";

export const ProblemSection = () => {
  const [headRef, headVisible] = useScrollAnimation();

  return (
    <section className="relative py-24 lg:py-32 overflow-hidden">
      {/* Warm gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-rose-50/40 to-orange-50/30" />
      {/* Animated gradient orbs */}
      <div className="absolute top-0 right-0 w-[350px] h-[350px] bg-rose-200/30 rounded-full blur-[100px] pointer-events-none orb-float-2" />
      <div className="absolute bottom-10 left-10 w-[250px] h-[250px] bg-amber-100/20 rounded-full blur-[80px] pointer-events-none orb-float-1" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div
          ref={headRef}
          className={`max-w-2xl transition-all duration-700 ease-out ${
            headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <span className="text-xs font-semibold tracking-widest uppercase text-rose-500">
            The Problem
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">
            Tender Management is Broken.
          </h2>
          <p className="mt-4 text-lg text-slate-400 leading-relaxed font-body">
            Businesses waste weeks navigating a process that should take hours.
          </p>
        </div>

        {/* Cards */}
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {painPoints.map((point, i) => (
            <PainPointCard key={point.id} point={point} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

const PainPointCard = ({ point, index }) => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });
  const Icon = point.icon;

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"
      }`}
      style={{ transitionDelay: `${index * 150}ms` }}
    >
      <div className="group relative rounded-2xl p-8 h-full bg-white/60 backdrop-blur-md border border-white/70 shadow-sm card-glow-rose overflow-hidden">
        {/* Animated glow overlay on hover */}
        <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none bg-gradient-to-br from-rose-100/40 via-transparent to-amber-50/30" />
        
        <div className="relative z-10">
          <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center mb-6 transition-all duration-500 group-hover:bg-rose-100 group-hover:shadow-lg group-hover:shadow-rose-200/50">
            <Icon size={22} className="text-rose-500" />
          </div>
          <h3 className="text-lg font-bold text-slate-900 mb-3">
            {point.title}
          </h3>
          <p className="text-[0.9rem] text-slate-500 leading-relaxed font-body">
            {point.description}
          </p>
        </div>
        
        {/* Number watermark */}
        <span className="absolute top-6 right-8 text-6xl font-black text-slate-200/40 select-none">
          {String(point.id).padStart(2, "0")}
        </span>
      </div>
    </div>
  );
};
